import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  text-align: center;

  ${Heading2} {
    font-family: ${fontFamily('sans')};
    margin-bottom: ${spacing('lg')};
  }

  p {
    font-size: ${fontSize('lg')};
    line-height: 1.5;

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('xl')};
    }
  }
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  margin-top: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
  }

  > div {
    max-width: 25rem;
    margin: auto;
  }
`;

export const StyledItemImage = styled.div`
  clip-path: polygon(0 10%, 100% 0, 95% 100%, 5% 90%);
  background-color: var(--out-of-office-yellow);

  img {
    display: block;
    opacity: 0.25;
  }
`;

export const StyledItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
  background-color: var(--out-of-office-blue);
  clip-path: polygon(0 0%, 100% 15%, 100% 100%, 0% 85%);
  margin-left: ${spacing('xl')};
  margin-right: ${spacing('xl')};
  margin-top: -${spacing('xl5')};
  padding: ${spacing('xl')} ${spacing('md')} ${spacing('xl2')};
  color: ${color('white')};
  text-align: left;
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  font-weight: ${fontWeight('black')};

  a {
    color: inherit;
    transition: 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const StyledItemDate = styled.span`
  font-size: ${fontSize('xs')};
  text-transform: uppercase;
  line-height: 1.333;
  font-weight: ${fontWeight('black')};
  color: ${color('navy_300')};
`;
